import { createRouteRef } from '@backstage/core-plugin-api';

export const redirectRouteRef = createRouteRef({
  id: 'appfolio.navigation.redirect',
});
